import { AuthProvider } from '@beukay/auth-mall';
import { message } from 'antd';
import { get as getCookie } from 'es-cookie';
import type { ReactElement } from 'react';
import { createElement } from 'react';
import { type RequestConfig, history } from 'umi';
import { Preloader } from '@/components';
import { API_CODES, RequestBaseUrlMap } from '@/services/constant';
import { LOCALE } from '@/utils';
import { APP_SOURCE } from '@/utils/constant';

message.config({
  maxCount: 1,
});

/**
 * url search 中 locale 值 > localStorage 中 locale 值 > 浏览器检测 > zh_CN
 */
export const locale = {
  getLocale() {
    return LOCALE.getLocale();
  },
};

export const request: RequestConfig = {
  baseURL: RequestBaseUrlMap[APP_ENV],
  errorConfig: {
    errorHandler() {},
    errorThrower() {},
  },
  requestInterceptors: [
    (config: { headers: any }) => {
      const token = getCookie('token');
      return {
        ...config,
        headers: {
          ...config?.headers,
          access_token: token,
          'X-LANG-MP': LOCALE.getLocale()?.toUpperCase(),
          'X-APP-SOURCE-MP': APP_SOURCE,
        },
      };
    },
  ],
  responseInterceptors: [
    (response) => {
      const { data = {} as any, config } = response;
      if (data.errorCode === API_CODES.NOT_LOG_IN) {
        const { headers } = config || {};
        const { href } = window.location;
        if (headers?.authLogin === true) {
          history.push({
            pathname: '/login',
            search: `callBackUrl=${encodeURIComponent(href)}`,
          });
        }
      }
      return response;
    },
  ],
};

export function onRouteChange({}) {
  window.scrollTo(0, 0);
}

export function rootContainer(container: ReactElement, ops: any) {
  return createElement(
    AuthProvider,
    {
      appSource: APP_SOURCE,
      tenantId: 100,
      isInitGetUser: false,
      env: APP_ENV,
    },
    createElement(Preloader, ops, container),
  );
}
